// Import the functions you need from the SDKs you need
import { initializeApp } from "https://www.gstatic.com/firebasejs/11.0.2/firebase-app.js";

// Storage imports
import { 
    getStorage, 
    ref as storageRef 
} from "https://www.gstatic.com/firebasejs/11.0.2/firebase-storage.js";

// Firestore imports
import {
    getFirestore,
    doc,
    getDoc,
    collection,
    query as firestoreQuery,
    where,
    getDocs,
    updateDoc,
    serverTimestamp,
    addDoc,
    arrayUnion,
    setDoc,
    FieldValue,
    writeBatch,
    Timestamp
} from "https://www.gstatic.com/firebasejs/11.0.2/firebase-firestore.js";

// Auth imports
import {
    getAuth,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    EmailAuthProvider,
    reauthenticateWithCredential,
    updatePassword // Bu satırı ekleyin
} from "https://www.gstatic.com/firebasejs/11.0.2/firebase-auth.js";

// Realtime Database imports
import { 
    getDatabase, 
    ref as databaseRef,
    push, 
    set, 
    onValue, 
    query as databaseQuery, 
    orderByChild, 
    equalTo 
} from "https://www.gstatic.com/firebasejs/11.0.2/firebase-database.js";

// Kilit mekanizması
class AsyncLock {
    constructor() {
        this.isLocked = false;
        this.queue = [];
    }

    async acquire() {
        if (!this.isLocked) {
            this.isLocked = true;
            return;
        }

        // Kilidi bekle
        await new Promise(resolve => this.queue.push(resolve));
    }

    release() {
        if (this.queue.length > 0) {
            // Sıradaki işlemi başlat
            const next = this.queue.shift();
            next();
        } else {
            this.isLocked = false;
        }
    }
}
// Action queue yönetimi için class
class ActionQueueManager {
    constructor() {
        this.QUEUE_KEY = 'pendingActions';
        this.LAST_SYNC_KEY = 'lastActionSync';
        this.SYNC_INTERVAL = 5 * 60 * 1000; // 5 dakika
        this.lock = new AsyncLock();
        this.initializeQueue();
        this.startSyncInterval();
    }

    initializeQueue() {
        if (!localStorage.getItem(this.QUEUE_KEY)) {
            localStorage.setItem(this.QUEUE_KEY, JSON.stringify([]));
        }
        if (!localStorage.getItem(this.LAST_SYNC_KEY)) {
            localStorage.setItem(this.LAST_SYNC_KEY, Date.now().toString());
        }
    }

    async addAction(userCode, actionType, details = {}) {
        try {
            await this.lock.acquire();
            const queue = JSON.parse(localStorage.getItem(this.QUEUE_KEY) || '[]');
            const nowDate = Timestamp.now()
            const formattedDate = formatFirestoreTimestamp(nowDate);
            const formattedTime = formatTimestampToTime(nowDate); // GG/SS:DD için

            queue.push({
                userCode,
                actionType,
                details,
                timestamp: formattedTime, // "25/14:30" formatında
                formattedDate,
                status: 'pending'
            });
            
            
            localStorage.setItem(this.QUEUE_KEY, JSON.stringify(queue));
            
            
            if (queue.length >= 10) {
                this.syncActions();
            }
        } catch (error) {
            console.error('Error adding action to queue:', error);
        } finally {
            this.lock.release();
        }
    }

    startSyncInterval() {
        setInterval(() => this.syncActions(), this.SYNC_INTERVAL);
    }

   
    async syncActions() {
        try {
            await this.lock.acquire();
            const queue = JSON.parse(localStorage.getItem(this.QUEUE_KEY) || '[]');
            if (queue.length === 0) return;

            
            
            for (const action of queue) {
                try {
                    const actionsRef = databaseRef(database, `userActions/${action.userCode}/${action.formattedDate}`);
                    const newActionRef = push(actionsRef);
                    
                    await set(newActionRef, {
                        t: action.actionType,
                        s: action.timestamp,
                        d: action.details
                    });
                    
                    
                } catch (error) {
                    console.error('Error syncing action:', action, error);
                }
            }

            localStorage.setItem(this.QUEUE_KEY, JSON.stringify([]));
            localStorage.setItem(this.LAST_SYNC_KEY, Date.now().toString());
            
        } catch (error) {
            console.error('Error in syncActions:', error);
        } finally {
            this.lock.release();
        }
    }
}

// Queue manager'ı oluştur ve export et
export const actionQueue = new ActionQueueManager();

// logUserAction2 fonksiyonunu güncelle ve export et
export async function logUserAction3(actionType, details = {}) {
    const userCode = localStorage.getItem('userName');
    await actionQueue.addAction(userCode, actionType, details);
}


let isProcessing = false;
let isLoggingOut = false;

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// İkinci Firebase projesi için config



// Firebase Configuration
const firebaseConfig = {
    apiKey: import.meta.env.VITE_USER_FB_API_KEY,
    authDomain: import.meta.env.VITE_USER_FB_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_USER_FB_PROJECT_ID,
    storageBucket: import.meta.env.VITE_USER_FB_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_USER_FB_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_USER_FB_APP_ID,
    measurementId: import.meta.env.VITE_USER_FB_MEASUREMENT_ID,
    databaseURL: import.meta.env.VITE_USER_FB_DB_URL
  };

// Firebase yapılandırması ve başlatma
const userApp = initializeApp(firebaseConfig, 'userAuth');
const userAuth = getAuth(userApp);
const userDb = getFirestore(userApp);
const database = getDatabase(userApp);

// Storage'a erişim
const storage = getStorage(userApp); 


// Kullanıcı aksiyonunu kaydetme fonksiyonu
async function logUserAction2(userId, actionType, details = {}) {
    try {

        const formattedDate = formatFirestoreTimestamp(Timestamp.now());
        const timestamp = Timestamp.now();
      const actionsRef = databaseRef(database, `userActions/${userId}/${formattedDate}`); // "actions" düğümü
      const newActionRef = push(actionsRef); // Yeni bir kayıt için referans oluştur
      await set(newActionRef, {
        userId: userId,
        actionType: actionType,
        timestamp: timestamp,
        details: details
    });
      
    } catch (error) {
      console.error("Aksiyon kaydedilirken hata oluştu:", error);
    }
  }

// Kullanıcı bilgilerini userCode ile getir
async function getUserDataByCode(userCode) {
    try {
        const usersRef = collection(userDb, "user");
        const q = firestoreQuery(usersRef, where("userCode", "==", userCode));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const userDoc = querySnapshot.docs[0];
            return {
                success: true,
                data: { ...userDoc.data(), docId: userDoc.id }  // docId'yi data içine ekle
            };
        } else {
            return { success: false, error: "Kullanıcı bulunamadı" };
        }
    } catch (error) {
        return { success: false, error: error.message };
    }
}

// Email ile giriş yap
async function loginWithEmail(email, password) {
    try {
        // Firebase Authentication ile giriş yap
        const userCredential = await signInWithEmailAndPassword(userAuth, email, password);
        
        // Authentication başarılı olduğunda uid'yi al
        const uid = userCredential.user.uid;
        
        // Firestore'dan kullanıcı bilgilerini al
        const usersRef = collection(userDb, "user");
        const q = firestoreQuery(usersRef, where("email", "==", email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const userDoc = querySnapshot.docs[0];
            const userData = userDoc.data();

            if (!userData.isActive) {
                // Kullanıcı aktif değilse Authentication'dan da çıkış yap
                await userAuth.signOut();
                throw new Error("Kullanıcı aktif değil");
            }

            // userCode ve docId'yi localStorage'a kaydet
            localStorage.setItem('userName', userData.userCode);
            localStorage.setItem('userDocId', userDoc.id);
            localStorage.setItem('userData', JSON.stringify(userData));
            localStorage.setItem('userEmail', email);
            localStorage.setItem('userUid', uid);
            
            // Login zamanını güncelle
            await updateLoginTime(userDoc.id);
            
            // Login aksiyonunu kaydet
            await logUserAction(userData.userCode, "LOGIN", {
                loginMethod: "email",
                emailVerified: userCredential.user.emailVerified
            });

            return {
                success: true,
                data: { 
                    ...userData, 
                    docId: userDoc.id,
                    uid: uid,
                    emailVerified: userCredential.user.emailVerified
                }
            };
        } else {
            // Firestore'da kullanıcı bulunamadıysa Authentication'dan çıkış yap
            await userAuth.signOut();
            throw new Error("Kullanıcı bilgileri bulunamadı");
        }
    } catch (error) {
        console.error("Login error:", error);
        // Hata durumunda Authentication oturumunu temizle
        try {
            await userAuth.signOut();
        } catch (signOutError) {
            console.error("Logout error:", signOutError);
        }
        return { success: false, error: error.message };
    }
}

// Yeni kullanıcı kaydı
async function registerUser(email, password, userData) {
    try {
        // Firebase Authentication'da kullanıcı oluştur
        const userCredential = await createUserWithEmailAndPassword(userAuth, email, password);

        // Firestore'a kullanıcı bilgilerini kaydet
        const userRef = doc(db, "user", userCredential.user.uid);
        await setDoc(userRef, {
            ...userData,
            email: email,
            isActive: true,
            createdAt: serverTimestamp(),
            lastLogin: null,
            lastLogout: null
        });

        return { success: true, userData: userData };
    } catch (error) {
        return { success: false, error: error.message };
    }
}


// Her işlem için ayrı kilit oluştur
const actionLock = new AsyncLock();
const logoutLock = new AsyncLock();

// Login işlemini güncelleyelim
async function loginWithUserCode(userCode) {
    try {
        const userData = await getUserDataByCode(userCode);
        if (!userData.success) {
            throw new Error(userData.error);
        }

        if (!userData.data.isActive) {
            throw new Error("Kullanıcı aktif değil");
        }

        // Son giriş zamanını güncelle
        await updateLoginTime(userData.data.docId);

        // Login aksiyonunu kaydet
        await logUserAction(userCode, "LOGIN", {
            loginMethod: "userCode"
        });

        return {
            success: true,
            userData: userData.data
        };
    } catch (error) {
        return { success: false, error: error.message };
    }
}

// Son giriş zamanını güncelle
async function updateLoginTime(docId) {
    try {
        const userRef = doc(userDb, "user", docId);
        await updateDoc(userRef, {
            lastLogin: serverTimestamp(),
        });
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
}

async function updateLogoutTime(docId, userCode) {
    try {
        await logoutLock.acquire(); // Kilidi al
        

        if (!docId) {
            throw new Error("Geçerli bir docId bulunamadı");
        }

        const userRef = doc(userDb, "user", docId);
        await updateDoc(userRef, {
            lastLogout: serverTimestamp(),
        });

        // Logout aksiyonunu kaydet
        await logUserAction(userCode, "LOGOUT", {
            logoutMethod: "manual"
        });

        await logUserAction2(userCode, "LOGOUT", {
            logoutMethod: "manual"
        });

        return { success: true };
    } catch (error) {
        console.error("Logout time update error:", error);
        return { success: false, error: error.message };
    } finally {
        logoutLock.release(); // Kilidi serbest bırak
    }
}


// Diğer aksiyon örnekleri için yardımcı fonksiyonlar
async function logProjectOpen(userCode, projectId) {
    return await logUserAction(userCode, "PROJECT_OPEN", {
        projectId: projectId
    });
}

async function logElementAdd(userCode, elementDetails) {
    return await logUserAction(userCode, "ELEMENT_ADD", elementDetails);
}

async function logElementDelete(userCode, elementDetails) {
    return await logUserAction(userCode, "ELEMENT_DELETE", elementDetails);
}

function formatFirestoreTimestamp(timestamp) {
    const date = timestamp.toDate();
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear().toString().slice(-2)}`;
}
function formatTimestampToTime(timestamp) {
    const date = timestamp.toDate();
    const day = date.getDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
    return `${day}/${hour}:${minute}`;
}
async function logUserAction(userCode, actionType, details = {}) {
    try {
        await actionLock.acquire(); // Kilidi al
        
        
        const formattedDate = formatFirestoreTimestamp(Timestamp.now());
        const timestamp = Timestamp.now();
        

        const actionsRef = collection(userDb, "userActions");
        const userActionDoc = doc(actionsRef, userCode + "-" + formattedDate);
       

        // Dökümanı kontrol et
        const docSnap = await getDoc(userActionDoc);

        if (docSnap.exists()) {
            await updateDoc(userActionDoc, {
                actions: arrayUnion({
                    actionType: actionType,
                    timestamp: timestamp,           // Firestore server timestamp
                    details: details,
                })
            });
        } else {
            const newAction = {
                actionType: actionType,
                timestamp: timestamp,
                details: details
            };

            await setDoc(userActionDoc, {
                userCode: userCode,
                actions: [newAction]
            });

        }
        await logUserAction2(userCode, actionType, {        // Firestore server timestamp
            details: details,
        });
        return { success: true };
    } catch (error) {
        console.error("Action logging error:", error);
        return { success: false, error: error.message }
    } finally {
        actionLock.release(); // Kilidi serbest bırak
      }
}

// Kullanıcının sayCount değerini güncelleme fonksiyonuhttp://localhost:5173/personal/#
export async function updateUserSayCount(userCode) {
    try {
        // Önce kullanıcı verisini al
        const userData = await getUserDataByCode(userCode);
        
        if (!userData.success) {
            throw new Error("Kullanıcı bulunamadı");
        }

        const userRef = doc(userDb, "user", userData.data.docId);
        const currentCount = parseInt(userData.data.sayCount) || 0;
        const newCount = currentCount + 1;
        const currentCount2 = parseInt(userData.data.activeprojectCount) || 0;
        const newCount2 = currentCount2 + 1;
        // sayCount'u güncelle
        await updateDoc(userRef, {
            sayCount: newCount.toString(),      
            activeprojectCount: newCount2.toString()
        });

        
        return { success: true, newCount };
    } catch (error) {
        console.error("Error updating sayCount:", error);
        return { success: false, error: error.message };
    }
}

export async function changeUserPassword(currentPassword, newPassword) {
    try {
  //      alert(localStorage.getItem('userName'))
        if (localStorage.getItem('userName') === 'BT') {
            alert("Bu kullanıcının şifresini değiştiremezsiniz")
            return;
        }
        if (localStorage.getItem('userName') === '') {
            alert("Bu kullanıcının şifresini değiştiremezsiniz")
            return;
        }

        const user = userAuth.currentUser;
        if (!user) {
            throw new Error('Oturum açık değil');
        }

        // Kullanıcıyı yeniden doğrula
        const credential = EmailAuthProvider.credential(user.email, currentPassword);
        await reauthenticateWithCredential(user, credential);
        
        // Şifreyi güncelle
        await updatePassword(user, newPassword);
        
        // Log action
        await logUserAction(localStorage.getItem('userName'), "PASSWORD_CHANGE", {
            timestamp: new Date().toISOString()
        });

        return { success: true };
    } catch (error) {
        console.error('Password change error:', error);
        let errorMessage = 'Şifre değiştirme hatası';
        
        // Hata mesajlarını özelleştir
        switch(error.code) {
            case 'auth/wrong-password':
                errorMessage = 'Mevcut şifre yanlış';
                break;
            case 'auth/weak-password':
                errorMessage = 'Yeni şifre çok zayıf';
                break;
            case 'auth/requires-recent-login':
                errorMessage = 'Lütfen tekrar giriş yapın';
                break;
            default:
                errorMessage = error.message;
        }
        
        return { success: false, error: errorMessage };
    }
}

/**
 * SLA ihlali sonrası bir kez gösterilecek ceza bildirimi.
 * getProject çağrısından önce tetiklenir; gösterildikten sonra kuyruk temizlenir.
 */
export async function showDigitLatePendingNotices(userDocId) {
    if (!userDocId) return;
    try {
        const userRef = doc(userDb, 'user', userDocId);
        const snap = await getDoc(userRef);
        if (!snap.exists()) return;

        const notices = snap.data().digitLatePendingNotices;
        if (!Array.isArray(notices) || notices.length === 0) return;

        const lines = notices.map((n) => {
            const name = n.project || n.projectId || 'Proje';
            const penalty = n.penaltyAdded != null ? n.penaltyAdded : 3;
            return `• ${name} (+${penalty} ceza)`;
        });

        alert(
            'Aşağıdaki proje(ler) 3 hafta içinde teslim edilmediği için teslimden kaldırıldı.\n' +
            'Aylık ceza kaydınıza +3 proje yazıldı.\n\n' +
            lines.join('\n'),
        );

        await updateDoc(userRef, { digitLatePendingNotices: [] });
    } catch (error) {
        console.error('[digitSLA] Ceza bildirimi hatası:', error);
    }
}

// Kullanıcı profilini güncelle
export async function updateUserProfile(userDocId, updatedData) {
    try {
        // Firebase'de güncelle
        const userRef = doc(userDb, "user", userDocId);
        await updateDoc(userRef, updatedData);

        // Log action
        await logUserAction(updatedData.userCode || localStorage.getItem('userName'), "PROFILE_UPDATE", {
            updatedFields: Object.keys(updatedData)
        });

        return { 
            success: true, 
            data: updatedData 
        };
    } catch (error) {
        console.error('Profile update error:', error);
        return { 
            success: false, 
            error: error.message || 'Profil güncellenirken bir hata oluştu' 
        };
    }
}
export {
    userAuth as auth,
    userDb as db,
    loginWithUserCode,
    loginWithEmail,
    registerUser,
    getUserDataByCode,
    updateLoginTime,
    updateLogoutTime
};

const users = [
    {
      activeprojectCount: "0",
      adress: "",
      company: "",
      email: "",
      info: "",
      isActive: true,
      lastLogin: new Date(),
      lastLogout: new Date(),
      lastname: "",
      name: "",
      note: "",
      phoneNumber: "",
      priceAction: "0₺",
      regCount: "0",
      reportprojects: "0",
      sayCount: "0",
      settings: "",
      tempInfo: "",
      userCode: "",  // Her kullanıcı için özel kod
      userRole: "user" // Varsayılan rol
    },
    // Diğer kullanıcılar için şablon
  ];
  
  // Firestore'da toplu güncelleme
  async function updateAllUsers() {
    const userCollection = collection(userDb, "user");
    const batch = writeBatch(userDb);
    
    // Tüm kullanıcıları al
    const querySnapshot = await getDocs(userCollection);
    
    querySnapshot.forEach((doc) => {
      batch.update(doc.ref, {
        activeprojectCount: "0",
        adress: "",
        company: "",
        info: "",
        isActive: true,
        lastLogin: new Date(),
        lastLogout: new Date(),
        name:"",
        lastname:"",
        note: "",
        phoneNumber: "",
        priceAction: "0₺",
        regCount: "0",
        reportprojects: "0",
        sayCount: "0",
        settings: "",
        tempInfo: "",
        userCode: "",
        userRole: "user"
        // Mevcut email, name, lastname, userCode gibi önemli alanları koruyoruz
      });
    });
  
    // Batch işlemini uygula
    await batch.commit();
    
  }
  
